import axios from "axios";

import { capitalize } from "@/utils/helpers/string.js";

export async function register(user) {

    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "register.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password:apiPassword
            },
            data: JSON.stringify({
                login: user.email,
                password: user.password,
                fname: user.pseudo,
                gender: user.gender,
                bdate: user.birthdate,
                btime: user.birthtime,
                bcity: user.birthcity,
                bcountry: user.birthcountry,
                timezone: user.timezone,
                lat: user.lat,
                lng: user.lng,
                bdatetime_tmz: `${user.birthdate} ${user.birthtime} ${user.timezoneOffset}`,
                rating: user.rating,
                language: user.language,
                astro: capitalize(user.astro.toString())
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }

}

export async function userEdit(user) {

    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_edit.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (user) {
        let cleanedObject = {
            id_person: user.id,
            login: user.email,
            fname: user.pseudo,
            gender: user.gender,
            bdate: user.birthdate,
            btime: user.birthtime,
            bcity: user.birthcity,
            bcountry: user.birthcountry,
            timezone: user.timezone,
            lat: user.lat,
            lng: user.lng,
            bdatetime_tmz: `${user.birthdate} ${user.birthtime} ${user.timezoneOffset}`,
            rating: user.rating,
            language: user.language,
            astro: capitalize(user.astro.toString())
        };

        if (user.password) {
            cleanedObject.password = user.password;
        }

        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password:apiPassword
            },
            data: JSON.stringify(cleanedObject)
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }

}

export async function login(user) {

    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "login.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (user) {

        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                login: user.email,
                password: user.password,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getUserInfo(user) {

    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_info.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (user.id) {

        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                id_person: user.id
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    } else {
        return "Cannot retrieve userInfo (user.id or token are missing)";
    }
}

export async function getmeFirsTime(id) {

    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_meFirstTime.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (id) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            // ID_PERSON should be replace by a lowercase version... someday
            /*data: JSON.stringify({
                id_person: id,
            })*/
            data: JSON.stringify({
                id_person: id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }

}

export async function getMe(user) {

    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_me.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                id_person: user.id,
                id_user: user.id_user,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getMeCircle(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_me_circle.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_person": user.id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

// export async function initUserInsight(user) {
//     const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
//     // const port = process.env.VUE_APP_API_PORT || "";
//     const route = "get_myCircleFirstTime.php";

//     const method = "POST";

//     const apiUsername = process.env.VUE_APP_API_USERNAME;
//     const apiPassword = process.env.VUE_APP_API_PASSWORD;

//     // Prod
//     if (user) {
//         return axios({
//             method: method,
//             url: `${baseUrl}/${route}`,
//             auth: {
//                 username: apiUsername,
//                 password: apiPassword
//             },
//             data: JSON.stringify({
//                 id_person: user.id,
//             })
//         }).then(res => {
//             return res;
//         }).catch(e => {
//             if (e.response) {
//                 return e.response;
//             }
//             return false;
//         });
//     }
// }

export async function getMeTimelineFirstTime(id) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_me_timelineFirstTime.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (id) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_person": id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getMeTimeline(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_me_timeline.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            /*   data: JSON.stringify({
                "id_person": user.id,
            })*/
            data: JSON.stringify({
                id_person: user.id,
                id_user: user.id_user,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getMeCycleFirstTime(id) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_me_cycleFirstTime.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (id) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            /*data: JSON.stringify({
                "id_person": id,
            })*/
            data: JSON.stringify({
                "id_person": id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getMeCycle(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_me_cycle.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            /*  data: JSON.stringify({
                "id_person": user.id,
            })*/
            data: JSON.stringify({
                id_person: user.id,
                id_user: user.id_user,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}


export async function getCompare(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_compare.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_person": user.id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getEvent(data) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_event.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (data) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_user": data.id_user,
                "id_person": data.id_person,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getEventAll(data) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_eventAll.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (data) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_user": data.id_user,
                "id_person": data.id_person,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function userEventAdd(event) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_event_add.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (event) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify(event)
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function userEventDelete(event) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_event_delete.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    if (event) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: {
                "id_event": JSON.stringify(event.id)
            }
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function userActivate(id) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_activate.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (id) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_person": id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function userPasswordResetEmail(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_password_reset_email.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "login": user.email
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function userPasswordResetUpdate(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_password_reset_update.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "reset_token": user.token,
                "password": user.password
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getMeCycleToday(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_me_cycleToday.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_person": user.id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}
export async function getHoroscope(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_horoscope.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_person": user.id
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

